import React from "react";
import { HeadingVariant, HeadingColors } from "../types/constants";

type SectionHeadingProps = {
    text: string;
    variant?: HeadingVariant;
};

export default function SectionHeading({ text, variant = HeadingVariant.DARK }: SectionHeadingProps) {
    const colorClass = HeadingColors[variant];

    return <h2 className={`uppercase font-medium text-2xl md:text-[32px]  leading-[48px] ${colorClass}`}>{text}</h2>;
}
